"use strict";
/**
 * Reporting time for PnL periods. Shared so the client labels "this month" the
 * same way the server buckets it.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PNL_TZ = void 0;
exports.zonedDay = zonedDay;
/**
 * Period boundaries are exchange time, not UTC and not per-user — it matches how
 * schedules run and keeps operators' numbers comparable.
 */
exports.PNL_TZ = "America/New_York";
/** `YYYY-MM-DD` for an instant in `tz` — `en-CA` formats exactly that shape. */
function zonedDay(at, tz = exports.PNL_TZ) {
    return new Intl.DateTimeFormat("en-CA", {
        timeZone: tz,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(at);
}
